import { render, staticRenderFns } from "./dm-detail-article.vue?vue&type=template&id=1aa8473a&scoped=true"
import script from "./dm-detail-article.vue?vue&type=script&lang=js"
export * from "./dm-detail-article.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-article.vue?vue&type=style&index=0&id=1aa8473a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8473a",
  null
  
)

export default component.exports